module.exports = function initCarousels( carousels ) {
    carousels = carousels || [];
    if( carousels.length > 0 ) {
        carousels.forEach( carousel => {
            let sliderType = carousel.getAttribute('data-carousel') || 'card';
            let cardsPerSlide = carousel.getAttribute('data-per-slide') || 3;
            //check for type of carousel
            const options = {
                card : {
                    type   : 'slide',
                    perPage: cardsPerSlide,
                    arrows: true,
                    pagination: true,
                    drag: true,
                    keyboard: true,
                    gap: '40px',
                    breakpoints: {
                        768: {
                            perPage: cardsPerSlide > 2 ? 2 : 1,
                        },
                        640: {
                            perPage: 1,
                        },
                    }                    
                }
            }
            const Splider = carousel;
            const SpliderDefaults = options[sliderType];
            const splide = new Splide( Splider, SpliderDefaults )
            splide.mount();
        } )
    }
    return false;
}

